if (!customElements.get("personalize-candle-flow")) {
  customElements.define(
    "personalize-candle-flow",
    class PersonalizeCandleFlow extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = document.querySelector(
          "#personalize-add-to-cart-btn"
        );
        this.personalizeBlock = document.querySelector("#personalize-block");
        this.personalizeOpenButton = document.querySelector(
          "#personalize-open-btn"
        );
        this.personalizeCloseButton = document.querySelector(
          "#personalize-close-btn"
        );
        this.personalizeForm = document.querySelector("#personalize-form");
        this.resultBackButton = document.querySelector(
          "#personalize-result-back-btn"
        );
        this.heroContent = document.querySelector("#product-hero-content");
        this.personalizeResultBlock = document.querySelector(
          "#personalize-result"
        );
        this.personaliseAddToCartBtn = document.querySelector(
          "#personalize-add-to-cart-btn"
        );
        this.loader = document.querySelector("#personalize-loader");

        if (document.querySelector(".cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      connectedCallback() {
        if (this.personalizeBlock) {
          this.personalizeOpenButton.addEventListener("click", () =>
            this.openPersonalizeModal()
          );
          this.personalizeCloseButton.addEventListener("click", () =>
            this.closePersonalizeModal()
          );
          this.personalizeForm.addEventListener("submit", (e) =>
            this.personalizeFormSubmit(e)
          );
          this.resultBackButton.addEventListener("click", () =>
            this.showPersonalizeBlock()
          );
          this.personaliseAddToCartBtn.addEventListener("click", () =>
            this.form.requestSubmit()
          );
          this.watchStandardInputs();
          this.watchCustomSelects();
          this.changeFragranceOptionByCustomSelect();
          this.watchRadioInputs();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const formData = new FormData(this.form);
        const variantId = formData.get("id");
        const payload = {};

        const bundleProp = formData.get("properties[_bundle]");

        if (bundleProp) {
          payload.properties = {
            _bundle: bundleProp,
          };
        }
        
        if (
          this.personalizeProperties &&
          Object.keys(this.personalizeProperties).length > 0
        ) {
          payload.properties = {
            ...this.personalizeProperties,
          };
        }

        const quantity = formData.get("quantity") || 1;

        window.BIRTHDATE_CART.addVariant({ id: variantId }, quantity, payload, {
          ensureUnique: this.dataset.ensureUnique === "true",
        }).finally(() => {
          setTimeout(() => {
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("loading");
          }, 10);
        });
      }

      openPersonalizeModal() {
        this.personalizeBlock.classList.remove("hidden");
        this.heroContent.classList.add("hidden");
      }

      closePersonalizeModal() {
        this.personalizeBlock.classList.add("hidden");
        this.heroContent.classList.remove("hidden");
      }

      personalizeFormSubmit(e) {
        e.preventDefault();
        if (!this.validatePersonalizeForm()) return;

        const formData = new FormData(e.target);
        const json = Object.fromEntries(formData.entries());
        this.personalizeProperties = json;

        this.onShowBookPreview(e);
        this.renderResultMarkup(json);
      }

      validateCustomSelects() {
        const requiredHiddenInputs = this.personalizeForm.querySelectorAll(
          'input[type="hidden"][required]'
        );
        let isValid = true;

        requiredHiddenInputs.forEach((input) => {
          const wrapper = input.closest(".custom-select");

          if (!input.value.length) {
            isValid = false;
            wrapper.classList.add("custom-select--error");
          } else {
            wrapper.classList.remove("custom-select--error");
          }
        });

        return isValid;
      }

      watchCustomSelects() {
        const customSelects =
          this.personalizeForm.querySelectorAll(".custom-select");

        customSelects.forEach((selectWrapper) => {
          const options = selectWrapper.querySelectorAll(".select-option");

          if (options.length === 0) return;

          options.forEach((option) => {
            option.addEventListener("click", () => {
              selectWrapper.classList.remove("custom-select--error");
            });
          });
        });
      }

      validateStandardInputs() {
        const fields = this.personalizeForm.querySelectorAll(
          'input[required]:not([type="hidden"]), textarea[required], select[required]'
        );

        let isValid = true;

        fields.forEach((field) => {
          const value = field.value.trim();
          if (!value.length) {
            isValid = false;
            field.classList.add("input--error", "border-[#ff564f]");
          } else {
            field.classList.remove("input--error", "border-[#ff564f]");
          }
        });

        return isValid;
      }

      watchStandardInputs() {
        const fields = this.personalizeForm.querySelectorAll(
          'input[required]:not([type="hidden"]), textarea[required], select[required]'
        );

        fields.forEach((field) => {
          field.addEventListener("input", () => {
            field.classList.remove("input--error", "border-[#ff564f]");
          });
        });
      }

      validatePersonalizeForm() {
        const isStandardValid = this.validateStandardInputs();
        const isCustomSelectsValid = this.validateCustomSelects();
        const isRadiosValid = this.validateRadioGroups();

        return isStandardValid && isCustomSelectsValid && isRadiosValid;
      }

      async onShowBookPreview(e) {
        e.preventDefault();
        const button = document.querySelector("#show-result-btn");
        const errorBox = document.querySelector("#personalize-error-message");

        button.disabled = true;
        button.classList.add("loading");
        const originalText = button.innerHTML;
        button.innerHTML = "Loading...";
        document.body.classList.add("lock");
        this.loader.classList.remove("!hidden");

        const formData = new FormData(this.personalizeForm);
        const json = Object.fromEntries(formData.entries());

        const cleanedParams = this.cleanParams(json);
        const requiredKeys = [
          "background",
          "fragrance",
          "compliment",
          "personName",
        ];
        const params = {};

        const uiReset = () => {
          this.showPersonalizeResult();
          button.disabled = false;
          button.classList.remove("loading");
          button.innerHTML = originalText;
          this.loader.classList.add("!hidden");
          document.body.classList.remove("lock");
        };

        for (const key of requiredKeys) {
          if (!cleanedParams[key]) {
            console.warn(`Missing required param: ${key}`);
          }
          params[key] = cleanedParams[key] || "";
        }

        const paramsString = JSON.stringify(params);

        if (this.lastPreviewParams === paramsString) {
          uiReset();
          return;
        }

        this.lastPreviewParams = paramsString;
        const queryString = new URLSearchParams(params).toString();
        const url = `https://api.fiocompanies.com/v1/products/compliment-candle/preview?${queryString}`;

        try {
          const previewImages = await this.getPreviewImages(url);

          window.addDynamicSlides(previewImages);
          window.addSlidesToProductModal(previewImages);
        } catch (error) {
          if (errorBox) {
            errorBox.classList.remove("hidden");
            setTimeout(() => {
              errorBox.classList.add("hidden");
            }, 8000);
          }
          console.error("Failed to load preview image:", error.message);
        } finally {
          uiReset();
        }
      }

      async getPreviewImages(url) {
        const response = await fetch(url);

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || "Failed to fetch preview image");
        }

        const data = await response.json();
        
        return data.images;
      }

      cleanParams(obj) {
        const cleaned = {};
        for (const key in obj) {
          if (key.startsWith("_")) {
            cleaned[key.substring(1)] = obj[key];
          } else {
            cleaned[key] = obj[key];
          }
        }
        return cleaned;
      }

      renderResultMarkup(personalizeProperties) {
        const { _background, _fragrance, _compliment, _personName } =
          personalizeProperties;

        const background = this.personalizeResultBlock.querySelector(
          "#result-background-print"
        );
        const fragrance =
          this.personalizeResultBlock.querySelector("#result-fragrance");
        const compliment =
          this.personalizeResultBlock.querySelector("#result-compliment");
        const person =
          this.personalizeResultBlock.querySelector("#result-person");

        if (background) background.textContent = _background;
        if (fragrance) fragrance.textContent = _fragrance;
        if (compliment) compliment.textContent = _compliment;
        if (person) person.textContent = _personName;
      }

      showPersonalizeResult() {
        if (!this.personalizeResultBlock) return;

        this.personalizeResultBlock.classList.remove("!hidden");
        this.personalizeBlock.classList.add("!hidden");
        this.heroContent.classList.add("hidden");
      }

      showPersonalizeBlock() {
        if (!this.personalizeResultBlock) return;

        this.personalizeResultBlock.classList.add("!hidden");
        this.personalizeBlock.classList.remove("!hidden");
      }

      changeFragranceOptionByCustomSelect() {
        const input = document.querySelector('input[name="_fragrance"]');
        const selects = document.querySelectorAll('select.form-select');

        if (!input) return;

        const syncSelects = () => {
          const inputValue = input.value.trim();

          selects.forEach(select => {
            let matchedOption = null;

            Array.from(select.options).forEach(option => {
              if (option.text.trim() === inputValue) {
                matchedOption = option;
              }
              option.selected = false;
            });

            if (matchedOption) {
              matchedOption.selected = true;            
              select.value = matchedOption.value;     
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        };

        input.addEventListener('input', syncSelects);

        const observer = new MutationObserver(syncSelects);
        observer.observe(input, { attributes: true, attributeFilter: ['value'] });
        syncSelects();
      }

      validateRadioGroups() {
        let isValid = true;

        const requiredRadios = this.personalizeForm.querySelectorAll(
          'input[type="radio"][required]'
        );
        const names = [...new Set(Array.from(requiredRadios).map(r => r.name))];
        
        names.forEach((name) => {
          const group = this.personalizeForm.querySelectorAll(`input[name="${name}"]`);
          const checked = Array.from(group).some((radio) => radio.checked);
          
          if (!checked) {
            isValid = false;
            group.forEach((radio) => {
              const label = this.personalizeForm.querySelector(`label[for="${radio.id}"]`);
              label.style.boxShadow = "0 0 0 3px #ff564f";
            });
          } else {
            group.forEach((radio) => {
              const label = this.personalizeForm.querySelector(`label[for="${radio.id}"]`);
              label.style.boxShadow = "";
            });
          }
        });

        return isValid;
      }

      watchRadioInputs() {
        const radios = this.personalizeForm.querySelectorAll('input[type="radio"][required]');
        const displayText = document.querySelector('#current-background-swatch-text');

        radios.forEach(radio => {
            radio.addEventListener('change', () => {
              const group = this.personalizeForm.querySelectorAll(`input[name="${radio.name}"]`);
              group.forEach(r => {
                const label = this.personalizeForm.querySelector(`label[for="${r.id}"]`);
                if (label) label.style.boxShadow = "";
              });

              const selectedLabel = this.personalizeForm.querySelector(`label[for="${radio.id}"]`);
              if (selectedLabel) selectedLabel.style.boxShadow = "0 0 0 3px #fff, 0 0 0 6px #000";

              if (displayText) {
                displayText.textContent = radio.value;
              } 
            });
          });
      }
    },
  );
}
